/* eslint-disable no-empty-pattern */
// import FormsApi from '@/api/formPublic'
import PrivateFormsApi from '@/api/formPrivate'
// import FormPublicApi from '@/api/formPublic/formPublic'
import uiHelper from '@/helpers/ui'
import { EventBus } from '@/eventBus.js'

export default {
  namespaced: true,

  state: {
    selectedFormId: '',
    selectedForm: {},
    allSubmissions: [],
    selectedSubmission: {},
    selectedSubmissionToken: '',
    // selectedSubmissionTokens: [],
    selectedSubmissionStats: null,
    selectedSubmissionSection: {},
    selectedSubmissionSummary: {},
    selectedSubmissionSubmitted: false,
    selectedSubmissionDetails: {},
    isSelectedSubmissionOnHold: false,
    submissionPageNumber: 1,
    submissionTotalPagesCount: 0,
    formType: '',
    formBaseURL: '',
    selectedStatsFilter: {}
  },

  getters: {
    selectedForm: state => state['selectedForm'],
    selectedFormId: state => state['selectedFormId'],
    allSubmissions: state => state['allSubmissions'],
    selectedSubmission: state => state['selectedSubmission'],
    selectedSubmissionToken: state => state['selectedSubmissionToken'],
    // selectedSubmissionTokens: state => state['selectedSubmissionTokens'],
    selectedSubmissionStats: state => state['selectedSubmissionStats'],
    selectedSubmissionDetails: state => state['selectedSubmissionDetails'],
    selectedSubmissionSections(state) {
      const selectedSubmission = state['selectedSubmission']

      return selectedSubmission.form_sections
    },
    selectedSubmissionSection: state => state['selectedSubmissionSection'],
    selectedSubmissionSummary: state => state['selectedSubmissionSummary'],
    selectedSubmissionSubmitted: state => state['selectedSubmissionSubmitted'],
    isSelectedSubmissionOnHold: state => state['isSelectedSubmissionOnHold'],
    isSubmissionSubmitted: () => false,
    submissionPageNumber: state => state.submissionPageNumber,
    submissionTotalPagesCount: state => state.submissionTotalPagesCount,
    selectedSectionQuestions(state) {
      if (state.selectedSubmissionSection.hasOwnProperty('questions'))
        return state.selectedSubmissionSection.questions
      return []
    },
    formType: state => state.formType,
    formBaseURL: state => state.formBaseURL,
    selectedStatsFilter: state => state.selectedStatsFilter,

    dashboardDefaultTagId: (_, __, rootState) => {
      return rootState.user.dashboardStats.length
        ? rootState.user.dashboardStats[0].tag_id
        : null
    }
  },

  mutations: {
    setSelectedFormId(state, id) {
      state.selectedFormId = id
    },

    setSelectedForm(state, form) {
      state.selectedForm = form
    },

    setAllSubmissions(state, submissions) {
      state.allSubmissions = submissions
    },

    addToAllSubmissions(state, submissions) {
      state.allSubmissions.push.apply(state.allSubmissions, submissions)
    },

    clearAllSubmissions(state) {
      state.allSubmissions = []
    },

    setSelectedSubmission(state, submission) {
      state.selectedSubmission = submission
    },

    setSelectedSubmissionDetails(state, data) {
      state.selectedSubmissionDetails = data
    },

    setSelectedSubmissionToken(state, token) {
      state.selectedSubmissionToken = token
    },

    setSelectedSubmissionStats(state, stats) {
      state.selectedSubmissionStats = stats
    },

    setSelectedSubmissionSection(state, section) {
      state.selectedSubmissionSection = section
    },

    setSelectedSubmissionSummary(state, summary) {
      state.selectedSubmissionSummary = summary
    },

    setIsSubmissionSubmitted(state, status) {
      state.isSubmissionSubmitted = status
    },

    setSubmissionTotalPagesCount(state, count) {
      state.submissionTotalPagesCount = count
    },

    setSubmissionPageNumber(state, pageNumber) {
      state.submissionPageNumber = pageNumber
    },

    setSelectedSubmissionOnHoldStatus(state, status) {
      state.isSelectedSubmissionOnHold = status
    },

    setFormType(state, type) {
      state.formType = type
    },

    resetSelectedForm(state) {
      state.selectedSubmission = {}
      state.selectedSubmissionToken = ''
      state.selectedSubmissionStats = null
      state.selectedSubmissionSection = {}
      state.selectedSubmissionSummary = {}
      // state.selectedSubmissionSubmitted = false
      state.selectedSubmissionDetails = {}
      state.isSelectedSubmissionOnHold = false
    },
    setSelectedStats(state, stats) {
      state.selectedStatsFilter = stats
    }
  },

  actions: {
    async getMyForms({ state, commit }, isPublic = undefined) {
      let response
      try {
        response = await PrivateFormsApi.getMyForms(isPublic)
        const forms = response.data.payload.forms
        const permissions = response.data.payload.permissions
        if (!isPublic) {
          commit('user/setPrivateForms', forms, { root: true })
        } else {
          commit('user/setPublicForms', forms, { root: true })
        }
        let form
        if (Object.keys(state.selectedForm).length) {
          form = state.selectedForm
        } else {
          form = forms[0]
        }
        commit('setSelectedForm', form)
        commit('setSelectedFormId', form.id)
        commit('user/setPermissions', permissions, { root: true })
        return response
      } catch (error) {
        if (!isPublic) {
          commit('user/setPrivateForms', [], { root: true })
        } else {
          commit('user/setPublicForms', [], { root: true })
        }
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        return null
      }
    },

    async getOpenSubmissions({ commit, state, getters }, args = {}) {
      let response
      try {
        response = await PrivateFormsApi.getOpenSubmissions({
          formId: state.selectedFormId,
          page: state.submissionPageNumber,
          tagId: args.tagId || getters.dashboardDefaultTagId,
          searchTerm: args.searchTerm,
          status: args.status
        })

        commit(
          'setSubmissionTotalPagesCount',
          response.data.payload.total_pages
        )
        if (response.data.payload.page === 1)
          commit('setAllSubmissions', response.data.payload.submissions)
        else commit('addToAllSubmissions', response.data.payload.submissions)
      } catch (error) {
        commit('clearAllSubmissions')
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
      }
      return response
    },

    async createNewSubmission(
      { commit, state },
      formId = state.selectedFormId
    ) {
      let response
      try {
        response = await PrivateFormsApi.createNewSubmission(formId)

        commit(
          'setSelectedSubmissionToken',
          response.data.payload.submission_token
        )
        // Setting up empty array of questions in every section
        let submission = response.data.payload.form
        submission.sections = submission.sections.map(section => ({
          ...section,
          questions: []
        }))
        commit('setSelectedSubmission', submission)
        commit('setSelectedFormId', response.data.payload.form.id)

        commit(
          'setSelectedSubmissionSection',
          response.data.payload.form.sections[0]
        )
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
      return response
    },

    // async openForm({ commit, state }, formId = state.selectedFormId) {

    //   try {
    //     const response = await FormsApi.getSubmissionDetails(formId)
    //     commit('setSelectedSubmission', response.data.payload)
    //   } catch (error) {
    //     throw error
    //   } finally {
    //     uiHelper.progressBarStatus(false)
    //   }
    // },

    async getSubmissionDetails(
      { commit, state },
      formId = state.selectedFormId
    ) {
      try {
        const response = await PrivateFormsApi.getSubmissionDetails(formId)
        let submission = response.data.payload.form
        submission.sections = submission.sections.map(section => ({
          ...section,
          questions: []
        }))
        commit('setSelectedSubmission', submission)
      } catch (error) {
        throw error
      }
    },

    async getSectionResponses(
      { state },
      { sectionId = state.selectedSubmissionSection.id, isPublicForm }
    ) {
      try {
        let response
        if (isPublicForm) {
          response = await PrivateFormsApi.getSectionResponses(sectionId)
          return response.data.payload
        } else {
          response = await PrivateFormsApi.getSectionResponses(sectionId)
          return response.data.payload
        }
      } catch (error) {
        throw error
      }
    },

    async submitSingleAnswer({ getters }, { data }) {
      try {
        let response
        response = await PrivateFormsApi.submitSingleAnswer(
          data,
          getters['selectedSubmissionToken'],
          getters['selectedFormId']
        )
        if (response.data.payload.hasOwnProperty('calculated'))
          EventBus.$emit('refOption', response.data.payload.calculated)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        if (error.response.data) {
          if (error.response.data.msg.hasOwnProperty('answer')) {
            let answer = error.response.data.msg.answer
            // eslint-disable-next-line no-unused-vars
            for (let i in answer) {
              // eslint-disable-next-line no-unused-vars
              for (let j in answer[i]) {
                for (let k = 0; k < answer[i][j].length; k++) {
                  uiHelper.showSnackbarMessage(
                    `${j} ${answer[i][j][k]}`,
                    'error'
                  )
                }
              }
            }
          }
        }
        throw error
      }
    },

    // async submitMultipleAnswers({ getters }, { data, isPublicForm }) {
    //   try {
    //     if (!isPublicForm)
    //       await PrivateFormsApi.submitMultipleAnswers(
    //         data,
    //         getters['selectedSubmissionToken']
    //       )
    //     else {
    //       await FormPublicApi.submitAnswer(
    //         data,
    //         getters['selectedSubmissionToken']
    //       )
    //     }
    //   } catch (error) {
    //     uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
    //     throw error
    //   }
    // },

    async submitForm() {
      let response
      try {
        response = await PrivateFormsApi.submitForm()
        uiHelper.showSnackbarMessage(response.data.msg)
        return response
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        return null
      }
    },

    async getSubmissionStats({ commit, getters }) {
      try {
        const response = await PrivateFormsApi.getSubmissionStats({
          submissionToken: getters['selectedSubmissionToken']
        })
        commit('setSelectedSubmissionStats', response.data.payload)
      } catch (error) {
        throw error
      }
    },

    async getSummary({ commit }) {
      try {
        const response = await PrivateFormsApi.getSubmissionSummary()

        commit('setSelectedSubmissionSummary', response.data.payload)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
    },

    async startNewFormSubmission({ commit }, formId) {
      try {
        const response = await PrivateFormsApi.startNewFormSubmission(formId)
        commit(
          'setSelectedSubmissionToken',
          response.data.payload.submission_token
        )

        // Setting up empty array of questions in every section
        let submission = response.data.payload.form
        let sections = submission.sections.filter(
          el => el.type === 'normal' || el.type === 'summary'
        )
        submission.sections = sections
        submission.sections = submission.sections.map(section => ({
          ...section,
          questions: []
        }))
        commit('setSelectedSubmission', submission)
        commit('setSelectedFormId', response.data.payload.form.id)

        commit(
          'setSelectedSubmissionSection',
          response.data.payload.form.sections[0]
        )
      } catch (err) {
        commit('setSelectedSubmission', {})
        commit('setSelectedFormId', '')

        commit('setSelectedSubmissionSection', {})
        uiHelper.showSnackbarMessage(err.response.data.msg, 'error')
      }
    },

    async getQuestionsBySection({ state, commit }) {
      try {
        if (!state.selectedSubmissionSection.questions.length) {
          let response
          response = await PrivateFormsApi.getQuestionsBySection(
            state.selectedSubmission.id,
            state.selectedSubmissionSection.id
          )

          let selectedSubmission = state.selectedSubmission

          const selectedSectionIndex = selectedSubmission.sections.findIndex(
            section => section.id === state.selectedSubmissionSection.id
          )

          selectedSubmission.sections[selectedSectionIndex].questions =
            response.data.payload.questions
          await commit('setSelectedSubmission', selectedSubmission)
        }
      } catch (err) {
        uiHelper.showSnackbarMessage(err.response.data.msg, 'error')
      }
    },

    // eslint-disable-next-line prettier/prettier
    async updateSubmissionHoldStatus({ }, { formId, data }) {
      try {
        const response = await PrivateFormsApi.updateSubmissionHoldStatus({
          formId,
          data
        })
        uiHelper.showSnackbarMessage(response.data.msg)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
    },
    async cancelSubmission({}, { formId }) {
      let response
      try {
        response = await PrivateFormsApi.cancelSubmission(formId)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
      uiHelper.progressBarStatus(false)
      return response
    },

    async generatePDF({}, submissionToken) {
      try {
        const response = await PrivateFormsApi.generatePDF(submissionToken)
        uiHelper.showSnackbarMessage(response.data.msg)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
    },
    async approveSubmission({}, { formId, data }) {
      try {
        const response = await PrivateFormsApi.approveSubmission(formId, data)
        return response
      } catch (error) {
        throw error
      }
    },
    async getPublicSubmissions(
      { commit },
      { formId, page = 1, searchTerm = '' }
    ) {
      let response = {}
      try {
        response = await PrivateFormsApi.getPublicSubmissions(
          formId,
          page,
          searchTerm
        )
        if (response.data.payload.page === 1)
          commit('setAllSubmissions', response.data.payload.submissions)
        else commit('addToAllSubmissions', response.data.payload.submissions)
        return response
      } catch (error) {
        commit('clearAllSubmissions')
        uiHelper.showSnackbarMessage(error.response?.data?.msg, 'error')
        return null
      }
    }
  }
}
